import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { User } from '../../model/user';
import { Role } from '../../model/role';
import { AppyUser } from 'src/app/core/model/v2/AppyUser';
import { HealthSystem } from '../../model/v2/healthSystem/health-system';
import { BaseService } from '../shared/base.service';
import { shareReplay } from 'rxjs/operators';
import { AppyProfessional } from '../../model/v2/AppyProfessional';

import { ResultBase } from '../../../core/models/result-base';
import { PagedResult } from '../../models/PageRequestInterface';
import { CreditCardPaymentInformation } from 'src/app/physician/models/healthSystemPaymentInformation';
import { UserPaymentProfile } from '../../models/UserPaymentProfile/userPaymentProfile';
import { UserActivity } from '../../../admin/models/user-activity.model';
import { MarketplaceActivity } from '../../../admin/models/marketplace-activity.model';
import { EMPUserSubscriptionFee } from '../../models/patient/patientFavoriteRequest';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient, private baseService: BaseService) { }

  /** @deprecated  the returnType of this methos is wrongly mapped (api v2 returns whitout first capital letters)
   * Also some fields like PratitionerID doesn't exist anymore on the model
  */
  getMe(): Observable<User> {
    return this.baseService.get<User>(`User/GetUserDetails`);
  }

  userDetail$: Observable<AppyUser>;

  clearGetUserDetailsCache() {
    this.userDetail$ = null;

  }

  getUserDetails(): Observable<AppyUser> {
    if (!this.userDetail$) {
      this.userDetail$ = this.requestUserDetail().pipe(shareReplay(50));
    }
    return this.userDetail$;
  }

  private requestUserDetail() {
    return this.baseService.get<AppyUser>('User/GetUserDetails');
  }

  rolesRoutedToPhysician: string[] = [
    "Front Desk",
    "Administrator",
    "Physician Assistant",
    "Nurse Practitioner",
    "Registered Nurse",
    "Physical Therapist",
    "Physician",
    "Licensed Vocational Nurse",
    "Registered Dental Hygienist",
    "Practice Manager"
  ];

  impersonate(userId: number, reloacateHref: string = 'home') {
    this.baseService.post<any>(`User/Impersonate/${userId}`, null)
      .subscribe(
        (r) => {
          this.clearGetUserDetailsCache();
          window.location.href = reloacateHref;
        }

      );
  }

  cancelImpersonate() {
    this.baseService.delete<any>(`User/Impersonate/`).subscribe(
      (r) => {
        this.clearGetUserDetailsCache();
        window.location.href = 'admin';
      }
    );
  }
  searchUserByEmail(email: string, pageIndex: number, pageSize: number): Observable<ResultBase<PagedResult<AppyUser>>> {

    return this.baseService.get<ResultBase<PagedResult<AppyUser>>>(`User/searchUser?email=${email}&pageIndex=${pageIndex}&pageSize=${pageSize}`)
  }

  impersonatePractitioner(practitionerId: number): Observable<string> {
    return this.httpClient.get<string>('/api/get?url=user/ImpersonatePractitioner/' + practitionerId);
  }

  stopImpersonating(): Observable<string> {
    return this.httpClient.get<string>('/api/get?url=user/StopImpersonating/');
  }

  getRoles(): Observable<Role[]> {
    return this.httpClient.get<Role[]>('/api/get?url=user/roles');
  }

  saveUser(user: User): Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/post?url=user/UpdateUserInfo`, user);
  }

  getMyHealthSystems(): Observable<HealthSystem[]> {
    return this.baseService.get<HealthSystem[]>(`User/myhealthsystems`);
  }

  getAllProfessionalsManagedByUser(): Observable<AppyProfessional[]> {
    return this.baseService.get<AppyProfessional[]>('User/GetAllProfessionalsManagedByUser');
  }

  toggleIsGlobalAdministratorFlag(userId: number): Observable<ResultBase<boolean>> {
    return this.baseService.post<ResultBase<boolean>>(`User/${userId}/ToggleIsGlobalAdministratorFlag`, null);
  }
  getUsersByRoleCategory(roleCategory: string): Observable<any> {
    return this.baseService.get<any>(`User/GetUsersByRoleCategory?roleCategory=${roleCategory}`);
  }

  InsertPaymentInformation(paymentInfo: CreditCardPaymentInformation): Observable<any> {
    return this.baseService.post<any>(`User/InsertPaymentProfiles`, paymentInfo);
  }

  GetPaymentInformation(authorizeNetUserID: string) {
    return this.baseService.get<UserPaymentProfile>(`User/GetPaymentProfiles?CustomerProfileID=${authorizeNetUserID}`);
  }

  DeletePaymentInformation(customerProfileId: string, customerPaymentProfileId: string) {
    return this.baseService.delete<UserPaymentProfile>(`User/DeletePaymentProfile?CustomerProfileID=${customerProfileId}&customerPaymentProfileId=${customerPaymentProfileId}`);
  }
  getUserActivity(): Observable<UserActivity[]> {
    return this.baseService.get<UserActivity[]>('User/GetUserActivity');
  }
  getMarketPlaceActivity(): Observable<MarketplaceActivity[]> {
    return this.baseService.get<MarketplaceActivity[]>('User/GetMarketPlaceActivity');
  }
  addUser(data: any): Observable<any> {
    return this.baseService.post<any>('User/AddUser', data);
  }

  filterEmployerBasedOnAgent(healthOrganizationId: number, roleCategory: string): Observable<any> {
    return this.baseService.get<any>(`User/GetUsersByRoleAndLoginUser?healthOrganizationId=${healthOrganizationId}&roleCategory=${roleCategory}`);
  }

chargeUserSubscriptionFee(subscriptionTypeId:number):Observable<any>{

  return this.baseService.post<any>(`User/ChargeUserSubscriptionFee?subscriptionTypeId=${subscriptionTypeId}`,[]);
}

}